// src/domains/core/dashboard/components/widgets/health/YazioNutritionWidget.tsx

import { Utensils } from "lucide-react";
import { type FC } from "react";

import { DailyStatsCard } from "@/domains/health/yazio/components/molecules/DailyStatsCard";
import { useYazioDailyCalories } from "@/domains/health/yazio/hooks/use-yazio-daily-calories";

import { useWidgetConfig } from "../../../hooks/useWidgetConfig";
import { WIDGET_IDS } from "../../../store/widgetRegistry";
import { WidgetContainer } from "../base";

/**
 * YazioNutritionWidget - Zeigt tägliche Nutrition Summary
 *
 * @returns {JSX.Element} Yazio nutrition widget component
 *
 */
export const YazioNutritionWidget: FC = () => {
  const { config } = useWidgetConfig(WIDGET_IDS.YAZIO_NUTRITION);
  const { data, error: errorMessage, isLoading, refreshData } = useYazioDailyCalories();

  return (
    <WidgetContainer
      description="Daily nutrition summary"
      error={errorMessage ?? null}
      icon={<Utensils className="w-5 h-5" />}
      loading={isLoading}
      onRefresh={refreshData}
      size={config?.size ?? "small"}
      title="Yazio Nutrition"
      widgetId={WIDGET_IDS.YAZIO_NUTRITION}
    >
      {data ? (
        <DailyStatsCard
          caloriesGoal={data.caloriesGoal}
          steps={data.steps}
          totalCalories={data.totalCalories}
          waterIntake={data.waterIntake}
        />
      ) : null}
    </WidgetContainer>
  );
};
